    extent: vm => vm.pagelet?.extent,
<template lang="pug">
v-col(:cols="extent")
  pagelet(
    v-bind="$props"
    @refresh="$emit('refresh')"
    @perform="opts => $emit('perform', opts)"
  )
</template>

<script>
import Pagelet from '@/components/pagelets/Pagelet'
// import widgets from '@/components/widgets'

export default {
  components: {
    Pagelet,
  },

  props: {
    site: String,
    eref: String,
    form: Object,
    data: Object,
    entity: Object,

    busy: Boolean,

    // @type {Keep.Paper.Design.Entity}
    pagelet: Object,
  },

  computed: {
    type: vm => vm.pagelet?.type,
    dock: vm => vm.pagelet?.dock,
    extent: vm => vm.pagelet?.extent || 12,
  },
}
</script>